import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  typeTab: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

export default useStyles;
